<template>
  <div
    class="drop mobile_reactions_wrap"
    :class="{ active: $store.state.mobile_reaction_pop_up }"
    v-click-outside="hide"
  >
    <Reactions />

    <button class="color_btn" @click="$store.commit('showModal', 'chat_modal')">
      Open chat
    </button>
  </div>
</template>

<script>
import Reactions from "@/components/Reactions";
import ClickOutside from "vue-click-outside";

export default {
  components: {
    Reactions,
  },

  methods: {
    hide() {
      this.$store.commit("showMobileReactionPopUp", false);
    },
  },

  mounted() {
    this.popupItem = this.$el;
  },

  directives: {
    ClickOutside,
  },
};
</script>

<style lang="scss" scoped>
.mobile_reactions_wrap {
  display: none;
  top: -148px;
  width: 100%;

  @media all and (max-width: 767px) {
    display: block;
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>